'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Wrestling = function (_PureComponent) {
  (0, _inherits3.default)(Wrestling, _PureComponent);
  function Wrestling() {
    (0, _classCallCheck3.default)(this, Wrestling);
    return (0, _possibleConstructorReturn3.default)(this, (Wrestling.__proto__ || (0, _getPrototypeOf2.default)(Wrestling)).apply(this, arguments));
  }
  (0, _createClass3.default)(Wrestling, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M17.2 17.6a1.203 1.203 0 0 1-1.608.733l-5.016-1.82a1.208 1.208 0 0 1-.685-.633l-.002-.008c-.146-.44-.295-1.01-.414-1.59l-.53.678L8 16.48l.208.208 2.928 3.2c.432.464.448.48.352 1.6l-.512 6.4a1.203 1.203 0 0 1-2.402-.064l.002-.067.32-5.357v-.72l-1.968-1.936.48 1.712a1.163 1.163 0 0 1-.273 1.09L2.08 27.76a1.2 1.2 0 0 1-1.773-1.604l3.534-3.853.113-.112.512-.543-1.36-3.792c-.234-.433-.37-.95-.37-1.496s.136-1.064.38-1.514L4.8 11.6l.96-1.76v-.097c.25-.49.615-.89 1.06-1.177a3.324 3.324 0 0 1 1.573-.392c.434 0 .85.082 1.23.232l3.865.872 4.384-.16.064-.002a1.202 1.202 0 0 1 .067 2.402l-3.97.08-2.833-.176.848 3.056 4.4 1.6a1.203 1.203 0 0 1 .75 1.53zm14.4 8.512l-4.4-4.432a20.852 20.852 0 0 0 2.234-3.742c.142-.428.193-.77.193-1.124 0-.834-.28-1.602-.753-2.214s-3.466-5.8-3.77-5.976a2.083 2.083 0 0 0-2.078-.363c-.66.25-1.21.7-1.578 1.28l-2.072 3.388-3.568-.464s-1.6-.32-1.856.848 1.136 1.36 1.136 1.36 3.872.656 4.624.832a1.312 1.312 0 0 0 1.26-.57l1.156-1.766v.096l.912 1.6.976 1.6L20.16 20.8a1.174 1.174 0 0 0-.365.472L17.6 26.528a1.2 1.2 0 0 0 .664 1.597 1.137 1.137 0 0 0 1.606-.582l2.355-5.8.288-.16 3.088-2.128a15.018 15.018 0 0 1-.646 1.697c-.095.147-.174.438-.174.747 0 .496.204.945.533 1.267L30 27.87a1.2 1.2 0 0 0 1.598-1.73zM21.376 2.928a2.224 2.224 0 1 0 0 4.45 2.224 2.224 0 0 0 0-4.45zm-10.912 0a2.224 2.224 0 1 0 2.224 2.24v-.016a2.224 2.224 0 0 0-2.224-2.224z'
      }));
    }
  }]);
  return Wrestling;
}(_react.PureComponent);
Wrestling.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Wrestling;